import React, { useState, useEffect } from "react";

export default function Preloader() {
  const [fade, setFade] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    // Hide after initial load
    const timer = setTimeout(() => {
      setFade(true);
      setTimeout(() => {
        setHidden(true);
      }, 1000);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  if (hidden) return null;

  return (
    <div
      id="preloader"
      className={fade ? "fade-out" : ""}
      style={{
        position: "fixed",
        inset: 0,
        background: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999999,
        overflow: "hidden",
      }}
      data-testid="indungi-preloader"
    >
      {/* ANIMATED BACKGROUND */}
      <div className="loader-bg" />

      {/* LOGO + TEXT + RING */}
      <div className="loader-content">
        <svg id="indungi-logo" width="380" height="70" viewBox="0 0 380 70" style={{ maxWidth: "90vw" }}>
          <defs>
            <linearGradient id="idgGrad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#ffffff" />
              <stop offset="50%" stopColor="#ff4f00" />
              <stop offset="100%" stopColor="#ff0000" />
            </linearGradient>
            <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
              <feGaussianBlur stdDeviation="6" result="blur" />
              <feMerge>
                <feMergeNode in="blur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
          </defs>
          <text
            x="50%"
            y="55%"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="url(#idgGrad)"
            filter="url(#glow)"
            style={{
              fontFamily: "'Chakra Petch', sans-serif",
              fontWeight: 900,
              fontSize: "34px",
              letterSpacing: "5px",
              textTransform: "uppercase"
            }}
          >
            INDUNGI ROMANIA
          </text>
        </svg>

        <div className="text-[11px] font-mono text-zinc-400 tracking-[0.3em] uppercase -mt-1">
          ESPORTS & GAMING COMMUNITY · EST. 2010
        </div>

        {/* LOADING RING (12 Dots in Circle) */}
        <div className="loading-ring mx-auto">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <style>{`
        /* ANIMATED BACKGROUND */
        .loader-bg {
            position: absolute;
            inset: 0;
            background: radial-gradient(circle, #700000 0%, #000000 70%);
            animation: bgMove 6s infinite linear;
            opacity: 0.6;
        }

        @keyframes bgMove {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
        }

        /* LOGO + TEXT */
        .loader-content {
            position: relative;
            text-align: center;
            animation: fadeIn 1.5s ease forwards;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        #indungi-logo text {
            animation: glowText 2s infinite ease-in-out;
        }

        @keyframes glowText {
            0% { opacity: 0.6; filter: drop-shadow(0 0 10px rgba(255, 79, 0, 0.4)); }
            50% { opacity: 1; filter: drop-shadow(0 0 25px rgba(255, 0, 0, 0.9)); }
            100% { opacity: 0.6; filter: drop-shadow(0 0 10px rgba(255, 79, 0, 0.4)); }
        }

        /* LOADING RING */
        .loading-ring {
            margin-top: 25px;
            width: 80px;
            height: 80px;
            position: relative;
        }

        .loading-ring div {
            position: absolute;
            width: 12px;
            height: 12px;
            background: #ff0000;
            border-radius: 50%;
            animation: ringAnim 1.2s linear infinite;
            box-shadow: 0 0 10px rgba(255, 0, 0, 0.8);
        }

        .loading-ring div:nth-child(1) { top: 0px; left: 34px; animation-delay: 0s; }
        .loading-ring div:nth-child(2) { top: 10px; left: 58px; animation-delay: 0.1s; }
        .loading-ring div:nth-child(3) { top: 34px; left: 68px; animation-delay: 0.2s; }
        .loading-ring div:nth-child(4) { top: 58px; left: 58px; animation-delay: 0.3s; }
        .loading-ring div:nth-child(5) { top: 68px; left: 34px; animation-delay: 0.4s; }
        .loading-ring div:nth-child(6) { top: 58px; left: 10px; animation-delay: 0.5s; }
        .loading-ring div:nth-child(7) { top: 34px; left: 0px; animation-delay: 0.6s; }
        .loading-ring div:nth-child(8) { top: 10px; left: 10px; animation-delay: 0.7s; }
        .loading-ring div:nth-child(9) { top: 5px; left: 20px; animation-delay: 0.8s; }
        .loading-ring div:nth-child(10) { top: 5px; left: 48px; animation-delay: 0.9s; }
        .loading-ring div:nth-child(11) { top: 60px; left: 48px; animation-delay: 1s; }
        .loading-ring div:nth-child(12) { top: 60px; left: 20px; animation-delay: 1.1s; }

        @keyframes ringAnim {
            0% { transform: scale(1); opacity: 1; }
            100% { transform: scale(0.3); opacity: 0.2; }
        }

        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
        }

        /* FADE OUT WHEN PAGE LOADS */
        .fade-out {
            animation: fadeOut 1s forwards ease;
        }

        @keyframes fadeOut {
            to { opacity: 0; visibility: hidden; }
        }
      `}</style>
    </div>
  );
}
